import React from 'react';
import { SectionHeader } from './ui/SectionHeader';
import { CtaBlock } from './ui/CtaBlock';
import { PRODUCT_NAME, tomos } from '../data/content';
export function SolutionSection() {
  return <section aria-labelledby="solucion" className="border-b border-line bg-canvas" data-id="element-130" data-mp="3o9trxz6mahzz">
      <div className="mx-auto max-w-3xl px-4 py-8 sm:py-10" data-id="element-131" data-mp="3jah4pdbu38wv">
        <SectionHeader id="solucion" eyebrow="La solución que estabas buscando — un sistema 6 en 1" title="6 tomos en un solo sistema, creados para aprender desde cero." data-id="element-132" data-mp="3j8w8lj9vfhww" />
        <p className="mt-3 text-center font-display text-sm font-extrabold text-accent sm:text-base" data-id="element-133" data-mp="3t6aonhrvu4oo">
          ⚡ {PRODUCT_NAME}
        </p>
        <p className="mx-auto mt-2 max-w-2xl text-center text-sm leading-snug text-muted" data-id="element-134" data-mp="5usz90hafhxe">
          No es simplemente otro ebook técnico. Es una ruta de aprendizaje que
          organiza los conocimientos fundamentales para que comprendas qué
          aprender primero, qué viene después y cómo se relacionan los
          diferentes componentes de un sistema de seguridad perimetral.
        </p>

        <ol className="mt-5 grid gap-2.5 sm:grid-cols-2" data-id="element-135" data-mp="3b974pmziljsx">
          {tomos.map((tomo, i) => <li key={tomo.title} className="flex gap-3 rounded-xl border border-line bg-surface p-3.5" data-id="element-136" data-mp="3faslhjf66i8e" data-mpi={i}>
              <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-lg bg-accent font-display text-base font-extrabold text-canvas" data-id="element-137" data-mp="3kancdmyy37tg">
                {i + 1}
              </span>
              <div data-id="element-138" data-mp="3u7rp6w6whqxl">
                <p className="font-display text-[0.7rem] font-semibold uppercase text-accent" data-id="element-139" data-mp="3u79u42vz5ir9">
                  Tomo {i + 1}
                </p>
                <h3 className="font-display text-sm font-extrabold leading-tight text-ink" data-id="element-140" data-mp="6vh88l5x4l8r">
                  {tomo.title}
                </h3>
                <p className="mt-1 text-[0.8rem] leading-snug text-muted sm:text-sm" data-id="element-141" data-mp="bvwllcq79sqq">{tomo.desc}</p>
              </div>
            </li>)}
        </ol>

        <CtaBlock note="" data-id="element-142" data-mp="2cwjn4m32cuac" />
      </div>
    </section>;
}